<section class="content">
  <h1>Auslieferug</h1>

  <p>
    Unter Cendrillon ou La petite pantoufle de verre finden Sie neben einer Inhaltsangabe und Motivübersicht auch
    Anmerkungen zum Vergleich der beiden Fassungen.
  </p>
  <form [formGroup]="deliveryForm" class="mt-l form-grid">
    <div class="form-left">
      <mat-form-field appearance="outline">
        <mat-label>Datum</mat-label>
      <input matInput [ngxMatDatetimePicker]="picker" formControlName="start" (keydown)="preventTyping($event)"
             (dateChange)="onDateTimeChange($event)">
      <button mat-icon-button matIconSuffix (click)="picker.open()" type="button">
        <span class="material-symbols-outlined">event</span>
      </button>
      <ngx-mat-datetime-picker #picker
                               [enableMeridian]="false"
                               [hideTime]="false"
                               [showSeconds]="false"
                               [disabled]="false"></ngx-mat-datetime-picker>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Kategorie</mat-label>
        <mat-select formControlName="category" (selectionChange)=setPeriods($event)>
          @for (category of this.categories; track category) {
            <mat-option [value]="category.url">
              {{ category.title }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Vendor</mat-label>
        <mat-select formControlName="period">
          @for (period of this.periods; track period) {
            <mat-option [value]="period.period_id">
              {{ period.vendor }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="form-right">
      <div (fileDropped)="onFileDropped($event)" class="dropzone text-center" dnd>
        <div class="m-l mt-m">
          <input (input)="onFileUploaded($event)" id="fileDrop" multiple="" type="file">
          <p>'Drag and drop' Datei</p>
          <p>oder</p>
          <label for="fileDrop">
            <button mat-flat-button color="primary">Datei auswählen</button>
          </label>
        </div>
      </div>
    <p>Dateinamen:<br>
      @for ( file of this.filename; track file) {
        {{ file.name}} <br>
      }
      </p>
    </div>

    <div class="form-spacer"></div>

    <div class="submit-button">
      <button (click)="submit()" mat-flat-button
              [disabled]="!isFormValid()"
              color="primary">Hochladen
      </button>
    </div>
  </form>

</section>
